import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
var root = ReactDOM.createRoot(document.getElementById('root'));
var NODE_ENV = process.env.NODE_ENV;
console.log('Application mode:' + NODE_ENV + ' mode');
if (NODE_ENV === 'development') {
    root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
}
else {
    root.render(_jsx(App, {}));
}
